const initialStatus = {
  dataSummaries: [],
  conversationId: null,
  loadingGetSummaries: false,
  loadingGenerateSummary: false,
}
export default function summaryReducer(state = initialStatus, action) {
  switch (action.type) {
    case 'SET_SUMMARIES':
      return {
        ...state,
        dataSummaries: action.payload,
        conversationId: action.conversationId,
        loadingGetSummaries: false,
      }
    case 'GET_SUMMARIES':
      return {
        ...state,
        dataSummaries: [],
        conversationId: null,
        loadingGetSummaries: true,
      }
    case 'GENERATE_SUMMARY':
      return {
        ...state,
        loadingGenerateSummary: true,
      }
    case 'SET_SUMMARY':
      return {
        ...state,
        loadingGenerateSummary: false,
      }
    case 'RESET_LOADING':
      return {
        ...state,
        loadingGetSummaries: false,
        loadingGenerateSummary: false,
      }
    default:
      return state
  }
}
